import { render, staticRenderFns } from "./ModalPresenter.vue?vue&type=template&id=54613a2c"
import script from "./ModalPresenter.vue?vue&type=script&lang=ts"
export * from "./ModalPresenter.vue?vue&type=script&lang=ts"
import style0 from "./ModalPresenter.vue?vue&type=style&index=0&id=54613a2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports